function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
export var transformToDrilldownProp = function transformToDrilldownProp(content) {
  return {
    title: 'Shop by department',
    items: _toConsumableArray(content.l1_navigation.map(function (l1) {
      var _l1$l1_navigation_lin, _l1$l1_navigation_lin2;
      var displayText = l1.l1_display_text || ((_l1$l1_navigation_lin = l1.l1_navigation_link[0]) === null || _l1$l1_navigation_lin === void 0 ? void 0 : _l1$l1_navigation_lin.title) || 'no display text for level 1';
      return {
        title: displayText,
        url: l1.l2_navigation.length ? '' : ((_l1$l1_navigation_lin2 = l1.l1_navigation_link[0]) === null || _l1$l1_navigation_lin2 === void 0 ? void 0 : _l1$l1_navigation_lin2.url) || '',
        items: l1.l2_navigation.map(function (l2) {
          var _l2$l2_navigation_lin, _l2$l2_navigation_lin2;
          return {
            title: l2.l2_display_text || ((_l2$l2_navigation_lin = l2.l2_navigation_link[0]) === null || _l2$l2_navigation_lin === void 0 ? void 0 : _l2$l2_navigation_lin.title) || 'no display text for level 2',
            url: ((_l2$l2_navigation_lin2 = l2.l2_navigation_link[0]) === null || _l2$l2_navigation_lin2 === void 0 ? void 0 : _l2$l2_navigation_lin2.url) || '',
            items: l2.l3_navigation.map(function (l3) {
              var _l3$l3_navigation_lin, _l3$l3_navigation_lin2;
              return {
                title: l3.l3_display_text || ((_l3$l3_navigation_lin = l3.l3_navigation_link[0]) === null || _l3$l3_navigation_lin === void 0 ? void 0 : _l3$l3_navigation_lin.title) || 'no display text for level 3',
                url: ((_l3$l3_navigation_lin2 = l3.l3_navigation_link[0]) === null || _l3$l3_navigation_lin2 === void 0 ? void 0 : _l3$l3_navigation_lin2.url) || '',
                items: [],
                level: 3
              };
            }),
            level: 2
          };
        }),
        level: 1
      };
    })),
    level: 0
  };
};